import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_SETTINGS = {
  phone_display: "07823 945998",
  email: "info@donsparklecleaning.co.uk",
  address: "Quarry Spring, Harlow CM20 3HS",
  hours: "Mon – Sat · 8am – 6pm",
  areas: ["Harlow", "Epping", "Bishop's Stortford", "Sawbridgeworth", "Stansted"],
  services: [
    { id: "domestic", name: "Regular Domestic", price_label: "£18 / hour" },
    { id: "deep", name: "Deep Clean", price_label: "£160 – £200" },
    { id: "tenancy", name: "End of Tenancy", price_label: "£230 – £260" },
    { id: "oven", name: "Oven Detailing", price_label: "from £55" },
    { id: "commercial", name: "Commercial & Office", price_label: "£18 – £25 / hour" },
  ],
  offer: {
    title: "10% off your first clean",
    subtitle: "Plus a free site visit and no-obligation quote",
  },
  extras: [
    { name: "Small offices", price_label: "£18 – £20 / hour" },
    { name: "Medium offices", price_label: "£20 – £22 / hour" },
    { name: "Large offices", price_label: "£22 – £25 / hour" },
    { name: "Interior windows", price_label: "from £35" },
    { name: "Carpet refresh", price_label: "from £45" },
    { name: "Weekly & monthly contracts", price_label: "save up to 10%" },
  ],
  reviews: [
    {
      quote: "They transformed our flat for the end-of-tenancy inspection — the letting agent said it was the cleanest handover they'd seen. Full deposit back.",
      name: "Amelia R.",
      place: "Harlow, CM20",
    },
    {
      quote: "Every Thursday the house feels like a boutique hotel. The same lovely cleaner each week, and the little details never slip.",
      name: "James T.",
      place: "Epping",
    },
    {
      quote: "Our studio office has never looked better — clients notice. Reliable, discreet, and always out of hours so we never lose a working minute.",
      name: "Priya S.",
      place: "Bishop's Stortford",
    },
  ],
  gallery: [
    {
      label: "Kitchen deep clean",
      before_url: "https://images.unsplash.com/photo-1663811396500-d128a4df7369?crop=entropy&cs=srgb&fm=jpg&q=85",
      after_url: "https://images.unsplash.com/photo-1663811396500-d128a4df7369?crop=entropy&cs=srgb&fm=jpg&q=85",
    },
    {
      label: "Bathroom restoration",
      before_url: "https://images.unsplash.com/photo-1737372826589-baf8fd032d2f?crop=entropy&cs=srgb&fm=jpg&q=85",
      after_url: "https://images.unsplash.com/photo-1737372826589-baf8fd032d2f?crop=entropy&cs=srgb&fm=jpg&q=85",
    },
    {
      label: "Faucet detailing",
      before_url: "https://images.unsplash.com/photo-1773177930141-4159d1cf900c?crop=entropy&cs=srgb&fm=jpg&q=85",
      after_url: "https://images.unsplash.com/photo-1773177930141-4159d1cf900c?crop=entropy&cs=srgb&fm=jpg&q=85",
    },
  ],
};

export const telHref = (display) =>
  "tel:+44" + String(display || "").replace(/\s/g, "").replace(/^0/, "");

const Ctx = createContext(DEFAULT_SETTINGS);

export const useSettings = () => useContext(Ctx);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then((r) => setSettings({ ...DEFAULT_SETTINGS, ...r.data }))
      .catch(() => {});
  }, []);

  return <Ctx.Provider value={settings}>{children}</Ctx.Provider>;
}
